"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
exports.__esModule = true;
exports.getStringsForExperience = exports.updateLangAttribute = exports.DEFAULT_LANGUAGE_CODE = exports.SUPPORTED_LANGUAGES = void 0;
var lib_i18n_1 = require("@doordash/lib-i18n");
var lodash_merge_1 = __importDefault(require("lodash.merge"));
var enums_1 = require("../Common/utils/enums");
var de_de = __importStar(require("./translations/de-DE.json"));
var en_us = __importStar(require("./translations/en-US.json"));
var es = __importStar(require("./translations/es.json"));
var fr_ca = __importStar(require("./translations/fr-CA.json"));
var ja_jp = __importStar(require("./translations/ja-JP.json"));
exports.SUPPORTED_LANGUAGES = {
    en: {
        code: lib_i18n_1.Locale.EN,
        name: 'English'
    },
    fr: {
        code: lib_i18n_1.Locale.FR,
        name: 'Français'
    },
    es: {
        code: lib_i18n_1.Locale.ES,
        name: 'Español'
    },
    ja: {
        code: lib_i18n_1.Locale.JA,
        name: '日本語'
    },
    deDe: {
        code: lib_i18n_1.Locale.DE_DE,
        name: 'Deutsche'
    }
};
var i18n = lib_i18n_1.createI18nInstance({
    localizedStrings: (_a = {},
        _a[lib_i18n_1.Locale.EN_US] = en_us,
        _a[lib_i18n_1.Locale.EN] = en_us,
        _a[lib_i18n_1.Locale.EN_CA] = en_us,
        _a[lib_i18n_1.Locale.EN_AU] = en_us,
        _a[lib_i18n_1.Locale.EN_NZ] = en_us,
        _a[lib_i18n_1.Locale.FR] = fr_ca,
        _a[lib_i18n_1.Locale.FR_CA] = fr_ca,
        _a[lib_i18n_1.Locale.ES_US] = es,
        _a[lib_i18n_1.Locale.ES_MX] = es,
        _a[lib_i18n_1.Locale.ES] = es,
        _a[lib_i18n_1.Locale.JA_JP] = ja_jp,
        _a[lib_i18n_1.Locale.JA] = ja_jp,
        _a[lib_i18n_1.Locale.DE_DE] = de_de,
        _a)
});
exports.DEFAULT_LANGUAGE_CODE = exports.SUPPORTED_LANGUAGES.en.code;
exports.updateLangAttribute = function (language) {
    if (document && document.documentElement) {
        document.documentElement.lang = language;
    }
};
function getStringsForExperience(doorDashStrings, experience) {
    if (experience === enums_1.Experience.Caviar) {
        return lodash_merge_1["default"](doorDashStrings, doorDashStrings.caviar);
    }
    return doorDashStrings;
}
exports.getStringsForExperience = getStringsForExperience;
exports["default"] = {
    t: function (key, options) { return i18n.t(key, options); },
    changeLocale: function (value) {
        i18n.changeLocale(value);
        exports.updateLangAttribute(value);
    },
    language: i18n.getCurrentLocale()
};
